(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anniversary-2026-assets"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-anniversary-2026-script')
    if (!window.anniversary2026 && $url) {
      window.anniversary2026 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.anniversary2026
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["application-form-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-application-form-script-v2');
    if (!window.applicationFormV2Script && $url && $url.dataset.designMode !== 'yes') {
      window.applicationFormV2Script = $url.value;
      var $script = document.createElement('script');
      $script.src = window.applicationFormV2Script;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["application-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-application-form-script');
    if (!window.applicationFormScript && $url && $url.dataset.designMode !== 'yes') {
      window.applicationFormScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.applicationFormScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-auto-cards-scroller-script')
    if (!window.autoCardsScroller && $url) {
      window.autoCardsScroller = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.autoCardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    var $url2 = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url2) {
      window._gsapCreative = $url2.value

      var $script2 = document.createElement('script')
      $script2.src = window._gsapCreative
      $script2.defer = "defer"
      document.body.appendChild($script2)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-sale-assets"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-christmas-sale-2025-script')
    if (!window.christmasSale2025 && $url) {
      window.christmasSale2025 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.christmasSale2025
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-with-dropdown-new"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-compare-with-dropdown-script')
    if (!window.compareWithDropdown && $url) {
      window.compareWithDropdown = $url.value

      var $script = document.createElement('script')
      $script.src = window.compareWithDropdown
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    var $url2 = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url2) {
      window._gsapCreative = $url2.value

      var $script2 = document.createElement('script')
      $script2.src = window._gsapCreative
      $script2.defer = "defer"
      document.body.appendChild($script2)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-with-dropdown-pdp-xs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-compare-with-dropdown-pdp-xs-script')
    if (!window.compareWithDropdownPdpXs && $url) {
      window.compareWithDropdownPdpXs = $url.value

      var $script = document.createElement('script')
      $script.src = window.compareWithDropdownPdpXs
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    var $url2 = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url2) {
      window._gsapCreative = $url2.value

      var $script2 = document.createElement('script')
      $script2.src = window._gsapCreative
      $script2.defer = "defer"
      document.body.appendChild($script2)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-with-dropdown-pdp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-compare-with-dropdown-pdp-script')
    if (!window.compareWithDropdown && $url) {
      window.compareWithDropdown = $url.value

      var $script = document.createElement('script')
      $script.src = window.compareWithDropdown
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    var $url2 = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url2) {
      window._gsapCreative = $url2.value

      var $script2 = document.createElement('script')
      $script2.src = window._gsapCreative
      $script2.defer = "defer"
      document.body.appendChild($script2)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-with-dropdown"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-compare-with-dropdown-script')
    if (!window.compareWithDropdown && $url) {
      window.compareWithDropdown = $url.value

      var $script = document.createElement('script')
      $script.src = window.compareWithDropdown
      $script.defer = "defer"
      document.body.appendChild($script)
    }

    var $url2 = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url2) {
      window._gsapCreative = $url2.value

      var $script2 = document.createElement('script')
      $script2.src = window._gsapCreative
      $script2.defer = "defer"
      document.body.appendChild($script2)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-variant-compare-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverflow-sliders-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-coverflow-sliders-v3-script')
    if (!window.coverflowSliderV3 && $url && $url.dataset.designMode !== 'yes') {
      window.coverflowSliderV3 = $url.value

      var $script = document.createElement('script')
      $script.src = window.coverflowSliderV3
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creativity-spot-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spot-cards-script')
    if (!window.spotCards && $url) {
      window.spotCards = true

      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-intro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-design-intro-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid-change"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-change-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-image-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-full-screen-image-tab-script');
    if (!window.fullScreenImageTab && $url && $url.dataset.designMode !== 'yes') {
      window.fullScreenImageTab = $url.value;
      let $script = document.createElement('script');
      $script.src = window.fullScreenImageTab;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-image-card-with-tab-script');
    if (!window.imageCardWithTabScript && $url) {
      window.imageCardWithTabScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.imageCardWithTabScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards-v1"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-v1-script')
  if (!window.imageCardsV2 && $url && $url.dataset.designMode !== 'yes') {
    window.imageCardsV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCardsV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }

  var $url2 = document.querySelector('.as-scrolling-text-animation-script')
  if (!window._gsapCreative && $url2) {
    window._gsapCreative = $url2.value

    var $script2 = document.createElement('script')
    $script2.src = window._gsapCreative
    $script2.defer = "defer"
    document.body.appendChild($script2)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-v2-script')
  if (!window.imageCardsV2 && $url && $url.dataset.designMode !== 'yes') {
    window.imageCardsV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCardsV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }

  var $url2 = document.querySelector('.as-scrolling-text-animation-script')
  if (!window._gsapCreative && $url2) {
    window._gsapCreative = $url2.value

    var $script2 = document.createElement('script')
    $script2.src = window._gsapCreative
    $script2.defer = "defer"
    document.body.appendChild($script2)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-logo-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-with-tab-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v2-xs-pdp"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-journey-map-script')
    if (!$url || window._journeyMapLoaded) return
    window._journeyMapLoaded = true
    var $script = document.createElement('script')
    $script.src = $url.value
    $script.defer = 'defer'
    document.body.appendChild($script)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksp-intro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-text-animation-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-hero-video-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-kv-hero-video-v2-script')
    if (!window._kvHeroVideoV2 && $url) {
      window._kvHeroVideoV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window._kvHeroVideoV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-kv-hero-video-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-live-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-kv-live-video-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-and-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-and-reviews-script')
    if (!window.mediaAndReviews && $url && $url.dataset.designMode !== 'yes') {
      window.mediaAndReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaAndReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews-featured-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-featured-v2-script')
    if (!window._loadMediaReviewsFeatured && $url) {
      window._loadMediaReviewsFeatured = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviewsFeatured
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews-featured-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-featured-v3-script')
    if (!window._loadMediaReviewsFeaturedV3 && $url) {
      window._loadMediaReviewsFeaturedV3 = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviewsFeaturedV3
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews-featured"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-featured-script')
    if (!window._loadMediaReviewsFeatured && $url) {
      window._loadMediaReviewsFeatured = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviewsFeatured
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["middle-east-eid-2026-assets"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-middle-east-eid-2026-script')
    if (!window.middleEastEid2026 && $url) {
      window.middleEastEid2026 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.middleEastEid2026
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nested-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-nested-tabs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-media-sliders-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-pr-media-sliders-v2-script');
    if (!window.prMediaSlidersV2Script && $url && $url.dataset.designMode !== 'yes') {
      window.prMediaSlidersV2Script = $url.value;
      var $script = document.createElement('script');
      $script.src = window.prMediaSlidersV2Script;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-v2-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guide-cl"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-guide-cl-script')
    if (!window.productGuideCl && $url && $url.dataset.designMode !== 'yes') {
      window.productGuideCl = $url.value

      var $script = document.createElement('script')
      $script.src = window.productGuideCl
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-guide-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-bundle-fishing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-products-bundle-fishing-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenarios"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenarios-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scene-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scene-switch-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-banner-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-media-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-media-text-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sequence-animation"]) return;
  try {
    
  // (function() {
  //   var $url = document.querySelector('.as-sequence-animation-xs-pdp-script')
  //   if (!window.sequenceAnimation && $url && $url.dataset.designMode !== 'yes') {
  //     window.sequenceAnimation = $url.value

  //     var $script = document.createElement('script')
  //     $script.src = window.sequenceAnimation
  //     $script.defer = "defer"
  //     document.body.appendChild($script)
  //   }
  // })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-featured-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-slideshow-featured-script-v3');
    if (!window.slideshowFeaturedV3Script && $url && $url.dataset.designMode !== 'yes') {
      window.slideshowFeaturedV3Script = $url.value;
      var $script = document.createElement('script');
      $script.src = window.slideshowFeaturedV3Script;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-sliders-101"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-social-media-sliders-101-script')
    if (!window._socialMediaSliders101 && $url && $url.dataset.designMode !== 'yes') {
      window._socialMediaSliders101 = $url.value

      var $script = document.createElement('script')
      $script.src = window._socialMediaSliders101
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-sale-2026-assets"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spring-sale-2026-script')
    if (!window.springSale2026 && $url) {
      window.springSale2026 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.springSale2026
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepsflow-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-stepsflow-section-script-v2');
    if (!window.stepsflowSectionV2Script && $url && $url.dataset.designMode !== 'yes') {
      window.stepsflowSectionV2Script = $url.value;
      var $script = document.createElement('script');
      $script.src = window.stepsflowSectionV2Script;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepsflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-stepsflow-section-script');
    if (!window.stepsflowSectionScript && $url && $url.dataset.designMode !== 'yes') {
      window.stepsflowSectionScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.stepsflowSectionScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-store-cards-script');
    if (!window.storeCardsScript && $url) {
      window.storeCardsScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.storeCardsScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-subscribe-banner-v2-script');
    if (!window.subscribeBannerV2 && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBannerV2 = $url.value;
      var $script = document.createElement('script');
      $script.src = window.subscribeBannerV2;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-and-livechat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-subscription-and-livechat-script');
    if (!window.subscriptionAndLivechat && $url && $url.dataset.designMode !== 'yes') {
      window.subscriptionAndLivechat = $url.value;
      var $script = document.createElement('script');
      $script.src = window.subscriptionAndLivechat;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-and-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-subscription-and-product-cards-script')
    if (!window.subscriptionAndProductCards && $url && $url.dataset.designMode !== 'yes') {
      window.subscriptionAndProductCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscriptionAndProductCards
      $script.defer = 'defer'
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscription-v2-script')
    if (!window.subscriptionV2 && $url && $url.dataset.designMode !== 'yes') {
      window.subscriptionV2 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.subscriptionV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-with-image-stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
